import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GridApi, GridOptions, GridReadyEvent, ShouldRowBeSkippedParams } from "@ag-grid-community/core";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { CommonService } from "src/app/services/common.service";
import { WorkSheet, WorkBook, utils, read, writeFile } from "xlsx";

import {
  BulkColumnDefinition,
  BulkColumnDefintion,
  BulkUploadParams,
  ProcessBulkColumn,
  ProcessBulkPayload,
} from "src/app/models/common.model";
import { filter, takeUntil } from "rxjs/operators";
import { DialogActions } from "../dialogs/dialog.model";
import { HeaderService } from "./../header/header.service";
import {SnackbarComponent} from '../snackbar/snackbar.component';
import { Subject } from "rxjs";

@Component({
  selector: "app-bulk-dialog",
  templateUrl: "./bulk-dialog.component.html",
  styleUrls: ["./bulk-dialog.component.scss"],
})
export class BulkDialogComponent implements OnInit,OnDestroy {
  bulkType: string;
  bulkDefinition: BulkColumnDefintion[] = [];
  columnDefs;
  params: BulkUploadParams[];
  spin: boolean;
  bulkTypeName: string;
  error: boolean;
  successCount: number;
  private destroy$ = new Subject<void>();
  uploadActions: DialogActions[] = [
    {
      text: "Close",
      buttonStyle: "underline",
    },
    {
      text: "Download Template",
    },
  ];

  reviewActions: DialogActions[] = [
    {
      text: "Cancel",
      buttonStyle: "underline",
    },
    {
      text: this.dialogData.bulkType == 'AddOrderShipCost' ? "Update" : "Save",
    },
  ];
  gridApi: GridApi;
  gridOptions: GridOptions = {
    rowModelType: "clientSide",
    onGridReady: (e: GridReadyEvent) => {
      this.gridApi = e.api;
    },
    // onPasteStart: (e) => {
    // },
    // processDataFromClipboard: (params: ProcessDataFromClipboardParams): string[][] => {
    //   const amountToAdd = params.data.length - this.rowData.length;
    // this.gridApi?.setGridOption('rowData',Array.from({length: amountToAdd}, (_, i) => {Name: i + 1+'w'}))
    //   this.rowData = params.data;
    //   // See the rows by setting the this.rowData so it will be able to save the data
    //   // return null;
    //   return params.data;
    // },
    defaultColDef: {
      editable: true,
      sortable:false
    }
  };
  actions: DialogActions[];
  uploadedData: any[] = [];
  uploadBulkError: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public dialogRef: MatDialogRef<BulkDialogComponent>,
    private commonService: CommonService,
    private gridActionsService: GridActionsService,
    private snackBar: MatSnackBar,
    private headerService: HeaderService
  ) {}

  ngOnInit(): void {
    this.bulkType = this.dialogData.bulkType;
    this.bulkTypeName = this.gridActionsService.mapBulkTypeToName(
      this.bulkType
    );
    this.params = this.dialogData.params;
    const payload:any ={ bulkType : this.bulkType}
    if(this.dialogData.boxCount){
      payload.boxCount=this.dialogData.boxCount
    }
    this.commonService.GetBulkDefinition(payload).pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
      this.bulkDefinition = e.columns;
      const columnDefs = this.bulkDefinition.map((e: BulkColumnDefinition) => {
        return {
          field: e.name,
          //headerName: e.name,
          // validation: Dont remove
          // cellClass: (params) => {

          //   const value = params.value;
          //   if (value) {
          //     const number = +value;
          //     const boolean =
          //       value === "true" ? true : (value === "false" ? false : value);

          //     if (e.dataType === "decimal" || e.dataType === "int") {
          //       if (Number.isNaN(number)) {
          //         return "ag-grid-red-cell";
          //       } else {
          //         return "";
          //       }
          //     } else if (e.dataType === "boolean") {
          //       if (typeof boolean !== "boolean") {
          //         return "ag-grid-red-cell";
          //       } else {
          //         return "";
          //       }
          //     }
          //   } else {
          //     return '';
          //   }
          // },
        };
      })

      this.gridOptions.columnDefs = columnDefs;
    });

    this.actions = this.uploadActions;

    this.headerService.remoteActionBroadcaster
      .pipe(filter((e) => e.action === "ProcessBulk" || e.action === "UploadAmazonBox"))
      .subscribe((e) => {  
        if (e.response.responseType.toLowerCase() === "done" && !this.error) {
          if(this.bulkType === "CreatePlanBySku"){
            if(e.response.data)
            this.dialogRef.close(e.response.data);
          } else{
            this.dialogRef.close("refresh");
          }         
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Changes Saved Successfully', 
                  action: 'Dismiss',
                  type: 'success',
                },
              }
          );
        } else if (e.response.responseType.toLowerCase() === "error") {
          this.error = true;
          this.replaceGridWithErrors(e.response.errors);
          this.reviewActions[0] = {
            text: "Download Errors",
            buttonStyle: "underline",
            spin: false,
          };
          this.reviewActions[1] = {
            text: "Close",
            spin: false,
          };
        }
      });
  }

  replaceGridWithErrors(errors: any) {
    const errorIds = Object.keys(errors);
    this.successCount = this.uploadedData.length;
    this.uploadedData = this.uploadedData
      .map((e, index) => {
        e.error = errors[index];
        return e;
      })
      .filter((e, index) => errorIds.includes(index.toString()));

      this.gridOptions.columnDefs.push(
        {
          headerName: "Error",
          field: "error",
          pinned: 'right',
          editable: false,
          resizable: true,
          cellStyle: {
            'color': 'var(--color-accent)'
          }
        }
      )
      this.gridApi.setGridOption('columnDefs', this.gridOptions.columnDefs);
  }

  downloadTemplate(): void {
    const header = this.bulkDefinition.map((e) => e.name);
    const ws: WorkSheet = utils.aoa_to_sheet([header]);
    const wb: WorkBook = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    writeFile(wb, this.bulkTypeName + ".csv");
  }

  downloadErrors() {
    this.gridApi.exportDataAsCsv({
      shouldRowBeSkipped: (params: ShouldRowBeSkippedParams): boolean => {
        return params.node.data?.error ? false : true;
      },
    });

    this.dialogRef.close("refresh");
  }

  save() {
   this.reviewActions[1].spin = true;
   this.uploadBulkError = false;
   let idx = this.uploadedData.findIndex((res) => !res.Product);
    if(this.dialogData.bulkType == 'SkuMapping' && idx !== -1 ){
      this.reviewActions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Product is required',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
      return;
    }
    const payload: ProcessBulkPayload = {
      bulkType: this.bulkType,
      createWhenNotExists: true,
      params: this.params,
      rows: this.uploadedData.map((e) => {
        return {
          columns: this.bulkDefinition
            .filter((column) => e[column.name] != null && e[column.name] !== "")
            .map((column) => {
              const data: ProcessBulkColumn = {
                propertyName: column.name,
              };
              if (column.dataType === "string") {
                data.stringValue = e[column.name].trim();
              } else if (column.dataType === "decimal") {
                data.decimalValue = e[column.name];
              } else if (column.dataType === "int") {
                data.intValue = e[column.name];
              } else if (column.dataType === "bool") {
                data.boolValue =    ['on', 'yes', 'true'].includes(e[column.name].toLowerCase())
              } else if (column.dataType === "date") {
                const date = new Date(e[column.name]);
                date.setHours(0, 0, 0, 0);
                data.dateValue = date;
              }
              return data;
            }),
          // columns: Object.keys(e).map((key) => {
          //   return {
          //     propertyName: key,
          //   };
          // }),
        };
      }),
    };
  this.uploadedData.forEach((res) => {
    let keys = [];
    const columnsForValidate=['Length','Width','Height','Weight'];
    columnsForValidate.forEach((key)=>{
      if((res.hasOwnProperty(key) && !Number.isInteger(+res[key]) && !(+res[key] % 1) || Number(+res[key]) < 0)){
        keys.push(key);
      }
    })
    const columnsForWholeInteger = ['LocalStock', 'Qty', 'totalQty'];
    columnsForWholeInteger.forEach((key) => {
      if ((res.hasOwnProperty(key) && !Number.isInteger(+res[key]))) {
        keys.push(key);
      }
    })
    if(keys.length){       
    let columns = keys.join(',');
          this.reviewActions[1].spin = false;
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: `${columns} should be whole integer values only.`,
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            )
          this.uploadBulkError = true;
        } 
  })
  if (!this.uploadBulkError) {
    if (payload.bulkType === "Vendors") {
       payload?.rows.forEach((res) => {
        res?.columns.forEach((ele) => {
          if (ele.propertyName == "Name" && ele.stringValue) {
            ele.stringValue = ele.stringValue.trim();
          }
        });
      });
    }
    let api= this.commonService.ProcessBulk(payload);
    if(this.bulkType == "CustomUploadForBox"){
      api= this.commonService.UploadAmazonBox(payload);
    }
    api.pipe(takeUntil(this.destroy$)).subscribe({
       next: (res) => {
         this.reviewActions[1].spin = true;
         //this.dialogRef.close();      
       },
      error: (err) => {
       this.reviewActions[1].spin = false;
       this.snackBar.openFromComponent(SnackbarComponent,
         {
           duration: 3000,
           horizontalPosition: 'center',
           data: {
             title: err.error.title,
             action: 'Dismiss',
             type: 'error',
           },
         }
       );
      }
    });
   }
  }

  custructSheet() {}

  action(e) {
    if (e === "Download Template") {
      this.downloadTemplate();
    } else if (e === "Download Errors") {
      this.downloadErrors();
    } else if (e === "Save" || e == "Update") {
      this.save();
    } else if (e === "Cancel" || e === "Close") {
      this.close(this.error ? 'refresh' : '');
    }
  }

  uploadData(data) {
  /*  data.forEach((res:any,index:number)=>{
      let duplicateSkus=data.filter((sku)=>sku.Sku === res.Sku && sku.BoxNumber === res.BoxNumber);
      if(duplicateSkus.length > 1){
       const qty = duplicateSkus.reduce((acc, obj) => acc + Number(obj.Qty), 0);
       data[index].Qty=qty;
       duplicateSkus.splice(0,1); 
       duplicateSkus.filter((res)=>{
        let idx= data.findIndex((box)=>box.Sku === res.Sku && box.BoxNumber === res.BoxNumber && box.Qty == res.Qty);
        if(idx !== -1){
         data.splice(idx,1);        
        }
       });   
      }
    })*/
    if(this.bulkType === "AddBoxContent"){
      data = data.sort((a, b) => a.BoxNumber - b.BoxNumber);
    }
    if(this.bulkType === "AddPo"){
      data.filter((po: any) => po.Qty = Number(po.Qty.split(',').join('')));
    }
    this.uploadedData = data;
    this.actions = this.reviewActions;
  }

  // mounted() {
  //   window.addEventListener("paste", this.insertNewRowsBeforePaste);
  // When paste is detected add first row and select first cell and pass the pasted data to the past function from AG GRID
  // }

  // insertNewRowsBeforePaste(event) {
  //   var self = this;
  // }

  close(action?) {
    this.dialogRef.close(action);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
